'use strict';

var _ = require('lodash');

/**
 * Flight Analysis - Segment Class tab (select a row in Cabin view) - Grid
 */
var FlightSegmentGridTransformerFactory = function FlightSegmentGridTransformerFactory(DataTransformer, mergeScenarioDataService, bookingsIntakeTransformationService, momentService, hepService, flightLiveDataService) {
  function FlightSegmentGridTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'segment-classes';
    this.targetType = 'segment-flight-analysis';
    this.priority = 1;
  }
  FlightSegmentGridTransformer.prototype = Object.create(DataTransformer.prototype);
  FlightSegmentGridTransformer.constructor = FlightSegmentGridTransformer;
  FlightSegmentGridTransformer.prototype.canTransform = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType === targetType;
  };
  FlightSegmentGridTransformer.prototype.isCacheable = function () {
    return true;
  };
  FlightSegmentGridTransformer.prototype.getCacheKey = function () {
    return this.sourceType + '-' + this.targetType;
  };
  function setLastRefreshTime(timeStamp) {
    if (timeStamp) {
      flightLiveDataService.setLastRefreshTime('segment-flight-analysis', momentService.of(timeStamp, momentService.FIELD.EVENT_TIME_STAMP));
    }
  }
  FlightSegmentGridTransformer.prototype.transform = function (data) {
    setLastRefreshTime(data.domain.timeStamp);
    var memorizedMomentOfDepartureDate = _.memoize(getMomentOfDate);
    var memorizedMomentOfEventDate = _.memoize(getMomentOfDate);
    var userSegmentTypes = {
      0: 'BOTH',
      1: 'LOCAL',
      2: 'CONNECT',
      get: function get(key) {
        return this[key] || this[0];
      }
    };
    var alertThreshold = hepService.getSimpleHepProperties().ALERT_THRESHOLD;
    var transformData = function transformData(segmentClasses) {
      var result = [];
      for (var i = 0, length = segmentClasses.length; i < length; i++) {
        var entry = segmentClasses[i];
        var flightDepartureDateMoment = memorizedMomentOfDepartureDate(entry.flightDepartureDate, momentService.FIELD.DEPARTURE_DATE);
        var segmentDepartureDateMoment = memorizedMomentOfDepartureDate(entry.segmentDepartureDate, momentService.FIELD.DEPARTURE_DATE);
        var eventTimeStamp = memorizedMomentOfEventDate(entry.eventTimeStamp, momentService.FIELD.EVENT_TIME_STAMP);
        var optGroupDateMoment = memorizedMomentOfDepartureDate(entry.optGroupDate, momentService.FIELD.DEPARTURE_DATE);
        var newEntry = {
          entryKey: entry.carrier + entry.segment + entry.flightNumber + entry.flightDepartureDate + entry.segmentClass + entry.segmentId,
          flightId: entry.flightId,
          referenceCurveFlightId: entry.referenceCurveFlightId,
          segmentId: entry.segmentId,
          segmentClassId: entry.segmentClassId,
          carrier: entry.carrier,
          scenarioName: entry.scenarioName,
          operatingCarrier: entry.operatingCarrier,
          flightNumber: entry.flightNumber,
          opsSuffix: entry.opsSuffix,
          flightDepartureDateMoment: flightDepartureDateMoment,
          segmentDepartureDateMoment: segmentDepartureDateMoment,
          segment: entry.segment,
          segmentClass: entry.segmentClass,
          segmentClassDisplaySeq: entry.segmentClassDisplaySeq,
          optGroupDate: optGroupDateMoment,
          daysToDeparture: entry.daysToDeparture,
          optGroupDateMoment: optGroupDateMoment,
          isSetAside: entry.setAside,
          waitList: entry.waitList,
          currentBookings: entry.currentBookings,
          currentGroupBookings: entry.currentGroupBookings,
          expectedBookings: entry.expectedBookings,
          lastYearCurrentBookings: entry.lastYearCurrentBookings,
          lastYearFinalBookings: entry.lastYearFinalBookings,
          segmentLimitType: userSegmentTypes.get(entry.segmentLimitType),
          segmentLimitResSys: entry.segmentLimitResSys,
          userSegmentLimitType: userSegmentTypes.get(entry.userSegmentLimitType),
          userSegmentLimitResSys: entry.userSegmentLimitResSys,
          demandFC: entry.demandFC,
          demandMWTP: entry.demandMWTP,
          mappedDemandFC: entry.mappedDemandFC,
          mappedDemandMWTP: entry.mappedDemandMWTP,
          appliedRules: entry.appliedRules,
          alerts: entry.alertScore,
          numberOfAlertRulesApplied: entry.numberOfAlertRulesApplied,
          alertThresholdExceeded: entry.alertScore > alertThreshold,
          eventTimeStamp: entry.eventTimeStamp,
          lastProcessedDateMoment: eventTimeStamp,
          latestChanges: entry.latestChanges,
          appliedRulesNumber: entry.appliedRules.length
        };
        bookingsIntakeTransformationService.calculateBookingsIntake(newEntry, entry);
        result.push(newEntry);
      }
      return result;
    };
    var productionData = transformData(data.domain.segmentClasses || data.domain.results);
    var scenarioData = transformData(data.secondDomain && (data.secondDomain.segmentClasses || data.secondDomain.results) || []);
    return mergeScenarioDataService.merge(productionData, scenarioData);
  };
  function getMomentOfDate(date, field, stringFormat) {
    return momentService.of(date, field, stringFormat);
  }
  return FlightSegmentGridTransformer;
};
FlightSegmentGridTransformerFactory.$inject = ['DataTransformerFactory', 'MergeScenarioDataService', 'BookingsIntakeTransformationService', 'MomentService', 'HepService', 'FlightLiveDataService'];
module.exports = FlightSegmentGridTransformerFactory;